"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavigationTree = _interopRequireDefault(require("./NavigationTree"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var NavigationForm = function NavigationForm(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));

  return /*#__PURE__*/_react["default"].createElement(_NavigationTree["default"], props);
};

NavigationForm.displayName = 'NavigationForm';
NavigationForm.propTypes = {
  values: _propTypes["default"].array,
  onSaveOrder: _propTypes["default"].func.isRequired
};
var _default = NavigationForm;
exports["default"] = _default;